// DriverList.jsx
import { useState, useMemo, useEffect } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { RxFilter } from "react-icons/rx";
import CustomPagination from "../common/CustomPagination";

export default function DriverList({
    driverData, onselectDriver, pagination, pageHandler ,search, setSearch
}) {
    const [filter, setFilter] = useState("All");
    const [selectedId, setSelectedId] = useState(driverData?.[0]?._id || null);
    const [loading, setLoading] = useState(false);

    // 🔍 CLIENT-SIDE SEARCH + FILTER (on current page data from server)
    const filteredData = useMemo(() => {
        return driverData?.filter((d) => {
            const s = search.toLowerCase();

            const matchSearch =
                d?.driver?.name?.toLowerCase().includes(s) ||
                d?.vehicle?.truck?.toLowerCase().includes(s) ||
                d?.location?.yard?.toLowerCase().includes(s);

            const matchFilter =
                filter === "All" || d?.status === filter;

            return matchSearch && matchFilter;
        }) ?? [];
    }, [search, filter, driverData]);

    // TAB COUNTS (from current page data)
    const tabCounts = useMemo(() => ({
        All: driverData?.length ?? 0,
        Active: driverData?.filter((d) => d?.status === "Active").length ?? 0,
        Inactive: driverData?.filter((d) => d?.status === "Inactive").length ?? 0,
    }), [driverData]);

    useEffect(() => {
    if (driverData?.length && !selectedId) {
        setSelectedId(driverData[0]?._id || driverData[0]?.driver?._id);
    }
}, [driverData]);

    return (
        <div className="dl-container">

            {/* SEARCH */}
            <div className="dl-search-box">
                <span className="icon left">
                    <RiSearch2Line className="text-primary" size={20} />
                </span>

                <input
                    placeholder="Search driver / truck "
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {/* TABS */}
            <div className="dl-tabs">
                {["All", "Active", "Inactive"].map((tab) => (
                    <span
                        key={tab}
                        className={filter === tab ? "active" : ""}
                        onClick={() => setFilter(tab)}
                    >
                        {tab} ({tabCounts[tab]})
                    </span>
                ))}
            </div>

            {/* LIST */}
            <div className="dl-list">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) :
                    filteredData.length > 0 ? (
                        filteredData.map((d, i) => (
                            <div
                                key={i}
                                className={`dl-item ${selectedId === d?._id ? "active" : selectedId === d?.driver?._id ? "active" : ""}`}
                                onClick={() => {
                                    setSelectedId(d?._id || d?.driver?._id);
                                    onselectDriver?.(d);
                                }}
                            >
                                <img src={d?.driver?.profile || "assets/images/placeholder.png"} alt={d?.driver?.name} width={40} height={40} className={ "rounded-5 object-fit-fill"} />

                                <div className="info">
                                    <h6 className="mb-0">{d?.driver?.name}</h6>
                                    <p className="fw-bold">{d?.vehicle?.truck}</p>
                                    <p>{d?.location?.yard}</p>
                                </div>

                                <div className="meta">
                                    <span className={`status ${d?.status?.toLowerCase()}`}>
                                        {d?.status}
                                    </span>
                                    <small>{d?.time}</small>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center text-muted py-3">No drivers found.</p>
                    )}
            </div>

            {/* PAGINATION */}
            <CustomPagination
                pagination={pagination}
                pageHandler={pageHandler}
            />

        </div>
    );
}